<template>
    <ModalFormCard class="modal-default lg:min-w-[800px]" :action='"/admin/company/" + company.id + "/system-options"'>
        <template #title>Edit {{ options.category[1].toLowerCase() }}</template>

        <template #default="{ saving, errors }">

            <div class="pb-4" v-if='systemOptions != null'>
                <h5 class="font-semibold">{{ options.category[1] }}</h5>
                <!-- <p class="text-12 text-grey-900">{{ options.category[2] }} required, {{ systemOptions._selected.length }} selected</p> -->
            </div>

            <input type="hidden" name="updateKey" :value="options.category[0]" />

            <InputCheckboxSelectableWrap
                v-if='systemOptions != null'
                name="selected"
                :options="systemOptions"
                :selectable="allSystemOptions"
            />

            <div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update
				</ButtonSaving>
            </div>
            
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import Company from '~/models/company.js'
    import Collect from '~/functions/collect.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                systemOptions: null,
                allSystemOptions: null,
            }
        },

        created() {
            this.$axios.get("/admin/actions/system-options", {
                params: {
                    category: this.options.category[0],
                    industry_id: this.company.industry_id,
                }
            }).then((res) => {
                this.allSystemOptions = res
                this.systemOptions = new Collect(res, this.company.selected_options)
                console.log(this.company.selected_options)
                console.log(res)
                console.log(new Collect(res, this.company.selected_options))
            })
        },

        computed: {
            company() {
                return this.editingModel
            }
        }
    }
</script>